import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
    PreloadAllModules,
    provideRouter,
    withPreloading,
} from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { headerConfigurationInterceptor } from './interceptors/header-configuration.interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';
import { TicketsService } from './ticket-changes/tickets.service';
import { DefaultService } from './ticket-changes/default.service';
import { SharedService } from './services/shared.service';
import { MessageService } from 'cax-design-system/api';
import {
    AuthConfig,
    authHttpInterceptorFn,
    provideAuth0,
} from '@auth0/auth0-angular';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        provideAnimations(),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideAuth0(environment.auth as AuthConfig),
        TicketsService,
        DefaultService,
        SharedService,
        MessageService,
    ],
};
